import { Icon } from '@eventbrite/eds-icon';
import { LogoWordmarkBrand } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { getEventbriteUrl } from '../utils';
import './PoweredByEventbriteText.scss';

export interface PoweredByEventbriteTextProps {
    disableLink?: boolean;
    isCheckoutForm: boolean;
    link?: string;
    locale: string;
    onClick: () => void;
}

const getPoweredByLinkUrl = ({
    link,
    locale,
}: Pick<PoweredByEventbriteTextProps, 'link' | 'locale'>) => {
    if (link) {
        return link;
    }

    return locale ? getEventbriteUrl(locale) : null;
};

// For now, this will always appear in English. See discussion here: https://jira.evbhome.com/browse/EB-60442
// You can either pass in a link (e.g. 'https://eventbrite.com') or a locale. If a locale is provided, we
// generate the link for that tld
const PoweredByEventbriteText: React.FunctionComponent<
    PoweredByEventbriteTextProps
> = ({ disableLink, link, locale, onClick }) => {
    const iconLink = disableLink ? null : getPoweredByLinkUrl({ link, locale });
    const href = iconLink ?? undefined;

    return (
        <a
            target="_blank"
            rel="noopener noreferrer"
            className="checkout-widget__powered-by-eventbrite eds-text-color--grey-600 eds-text-bs"
            title="Powered by Eventbrite"
            href={href}
            onClick={onClick}
        >
            {gettext('Powered by')}
            <Icon
                color="grey-600"
                type={<LogoWordmarkBrand />}
                size="medium"
                __containerClassName="checkout-widget__powered-by-eventbrite__icon"
            />
        </a>
    );
};

export default PoweredByEventbriteText;
